import { render, staticRenderFns } from "./ListFaturaextratoPage.vue?vue&type=template&id=2abd39e8&"
import script from "./ListFaturaextratoPage.vue?vue&type=script&lang=js&"
export * from "./ListFaturaextratoPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports